import React from 'react';
import ReactDOM from 'react-dom';
import Modal from 'react-modal';
import Root from './components/Root';
import './lib/init-datadog-rum';
import './stylesheets/main.scss';
import { unregister } from './registerServiceWorker';
import * as cptableData from 'xlsx/dist/cpexcel.js';
globalThis.cptable = cptableData;
import * as XLSX from 'xlsx';

['touchstart', 'touchmove', 'touchend', 'touchcancel', 'wheel'].forEach(
  (type) => {
    const orig = document.addEventListener.bind(document);
    document.addEventListener = (t, l, o, w) => {
      if (t === type)
        o =
          typeof o === 'object'
            ? { passive: false, ...o }
            : { capture: o, passive: false };
      return orig(t, l, o, w);
    };
  }
);

ReactDOM.render(<Root />, document.getElementById('root'));
Modal.setAppElement('#root');
unregister();

if (import.meta.hot) {
  import.meta.hot.accept('./components/Root', () => {
    const Next = require('./components/Root').default;
    ReactDOM.render(<Next />, document.getElementById('root'));
  });
}
